<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Kody PKWiU</div>
            <div class="text-md text-secondary">Włącz opcję wyboru kodów PKWiU dla pozycji na fakturach</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <div class="flex items-center space-x-3">
            <mat-slide-toggle 
                color="primary"
                [checked]="enablePKWiU"
                [disabled]="isProcessingEnable"
                (change)="toggleEnablePKWiU()">
            </mat-slide-toggle>
            <div class="text-sm text-gray-600 dark:text-gray-400">
                {{enablePKWiU ? 'Włączone' : 'Wyłączone'}}
            </div>
        </div>
        
        <!-- Informacja o funkcji -->
        <div class="mt-4 text-xs text-gray-500 dark:text-gray-400">
            <mat-icon class="icon-size-4 mr-1" [svgIcon]="'tabler_outline:info-circle'"></mat-icon>
            Po włączeniu tej opcji, w nowych dokumentach automatycznie będzie dostępna możliwość wyboru kodów PKWiU dla pozycji.
        </div>
    </div>
</div>

<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200 mt-6">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Wyświetlaj PKWiU na fakturach</div>
            <div class="text-md text-secondary">Czy kod PKWiU ma być wyświetlany na fakturach PDF</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <div class="flex items-center space-x-3">
            <mat-slide-toggle 
                color="primary"
                [checked]="showPKWiU"
                [disabled]="isProcessingShow"
                (change)="toggleShowPKWiU()">
            </mat-slide-toggle>
            <div class="text-sm text-gray-600 dark:text-gray-400">
                {{showPKWiU ? 'Włączone' : 'Wyłączone'}}
            </div>
        </div>
        
        <!-- Informacja o funkcji -->
        <div class="mt-4 text-xs text-gray-500 dark:text-gray-400">
            <mat-icon class="icon-size-4 mr-1" [svgIcon]="'tabler_outline:info-circle'"></mat-icon>
            Możesz ewidencjonować kody PKWiU bez wyświetlania ich na fakturach. Wyłącz tę opcję, jeśli chcesz tylko przechowywać kody PKWiU w systemie.
        </div>
    </div>
</div>

